module.exports = __webpack_public_path__ + "img/weibo.53f2ecf2.png";